<script>
  import {parametersGeneralNames}    from '../assets/js/parametersGeneralNames.js'
  import {parametersPerCompanyNames} from '../assets/js/parametersPerCompanyNames.js'

  export default {
    name: 'Options',
    props: {
      parametersGeneral: Object,
      parametersPerCompany: Object,
      parametersOthers: Array
    },
    data() {
      return {
        parametersGeneralNames: parametersGeneralNames,
        parametersPerCompanyNames: parametersPerCompanyNames,
        parametersWhich: {
          master: null,
          group: null,
          tab0: null,
          tab1: null,
        }
      }
    },
    methods: {
      getTabs(object) {
        let tabObj = {};
        for (const key in object) {
          if (object.hasOwnProperty(key) && /[0-9]+/.test(key)) {
            tabObj[key] = object[key];
          }
        }
        return tabObj;
      },
      sortObjItems(obj) {
        return obj.sort((a, b)=>{
          if (parseInt(a.ORDEM, 10) > parseInt(b.ORDEM, 10)) {
            return 1;
          }
          if (parseInt(a.ORDEM, 10) < parseInt(b.ORDEM, 10)) {
            return -1;
          }
            return 0;
        });
      },
      parametersWhichChange(type, value, emitParameters) {        
        if (typeof emitParameters != 'undefined') {
          let test = this.sortObjItems( emitParameters.filter(function(item) {
            return typeof item != 'undefined' ? item : null;
          }) );
          this.$emit('parameters', test);
        }

        if (type == 'master') {
          for (const key in this.parametersWhich) {
            if (this.parametersWhich.hasOwnProperty(key) && key != 'master') {
              this.parametersWhich[key] = null;
            }
          }
        }
        if (this.parametersWhich[type] == null || this.parametersWhich[type] != value) {
          this.parametersWhich[type] = value;
        } else {
          this.parametersWhich[type] = null;
          this.$emit('parameters', []);
        }
      }
    }
  }
</script>

<template>
  <ul class="options">
    <li class="options__item options__item--teste">
      <!-- Master -->
      <div 
        @click="parametersWhichChange('master', 0)"
        :class="['options__link', {'options__link--active':parametersWhich.master == 0}]"
      >
        <span class="options__title">Parametros</span>
        <span class="options__more">{{ parametersWhich.master == 0 ? '-' : '+' }}</span>
      </div>
      <ul 
        v-if="parametersWhich.master == 0"
        class="options"
      >
        <li
          v-for="(item, index) in parametersGeneral" 
          :key="index"
          class="options__item"
        >
          <!-- Group -->
          <div 
            @click="parametersWhichChange('group', index, item.ITENS)"
            :class="['options__link', {'options__link--active':parametersWhich.group == index}]"
          >
            <span class="options__title">{{ parametersGeneralNames[item.GRUPO].name }}</span>
            <span 
              v-if="Object.keys(getTabs(item)).length > 0"
              class="options__more"
              v-text="parametersWhich.group == index ? '-' : '+'"
            >
            </span>
          </div>
          <ul 
            v-if="Object.keys(getTabs(item)).length > 0 && parametersWhich.group == index"
            class="options"
          >
            <li
              v-for="(item2, index2) in getTabs(item)"
              :key="index2"
              class="options__item"
            >
              <!-- Tab 0 -->
              <div
                @click="parametersWhichChange('tab0', index2, parametersGeneral[item.GRUPO][index2])"
                :class="['options__link', {'options__link--active':parametersWhich.tab0 == index2}]"
              >
                <span class="options__title">{{ parametersGeneralNames[item.GRUPO].tab0[index2] }}</span>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </li>



    <li class="options__item">
      <!-- Master -->
      <div 
        @click="parametersWhichChange('master', 1)"
        :class="['options__link', {'options__link--active':parametersWhich.master == 1}]"
      >
        <span class="options__title">Parametros por empresa</span>
        <span class="options__more">{{ parametersWhich.master == 1 ? '-' : '+' }}</span>
      </div>
      <ul 
        v-if="parametersWhich.master == 1"
        class="options"
      >
        <li
          v-for="(item, index) in parametersPerCompany" 
          :key="index"
          class="options__item"
        >
          <!-- Group -->
          <div 
            @click="parametersWhichChange('group', index, item.ITENS)"
            :class="['options__link', {'options__link--active':parametersWhich.group == index}]"
          >
            <span class="options__title">{{ parametersPerCompanyNames[item.GRUPO].name }}</span>
            <span 
              v-if="Object.keys(getTabs(item)).length > 0"
              class="options__more"
              v-text="parametersWhich.group == index ? '-' : '+'"
            >
            </span>
          </div>
          <ul
            v-if="Object.keys(getTabs(item)).length > 0 && parametersWhich.group == index"
            class="options"
          >
            <li
              v-for="(item2, index2) in getTabs(item)"
              :key="index2"
              class="options__item"
            >
              <!-- tab 0 -->
              <div
                @click="parametersWhichChange('tab0', index2, parametersPerCompany[item.GRUPO][index2])"
                :class="['options__link', {'options__link--active':parametersWhich.tab0 == index2}]"
              >
                <span class="options__title">{{ parametersPerCompanyNames[item.GRUPO].tab0[index2] }}</span>
                <!-- <span 
                  v-if="Object.keys(getTabs(item2)).length > 0"
                  class="options__more"
                  v-text="parametersWhich.tab1 == index ? '-' : '+'"
                >
                </span> -->
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </li>



    <li class="options__item">
      <div 
        @click="parametersWhichChange('master', 3, parametersOthers) "
        :class="['options__link', {'options__link--active':parametersWhich.master == 3}]"
      >
        <span class="options__title">Outros</span>
      </div>
    </li>



  </ul>
</template>

<style scoped>
  .options {
    padding-left: .5rem;
  }
  .options__item {
    cursor: pointer;
    list-style: none;
  }
  .options__link {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: .625rem 1rem .625rem 1.125rem;
    border-top-left-radius: 1.125rem;
    border-bottom-left-radius: 1.125rem;
    user-select: none;
    position: relative;
  }
  .options__link:hover {
    background-color: #f1f3f5;
  }
  .options__link--active > .options__title,
  .options__link--active > .options__more {
    color: #1c7ed6;
  }
  .options__title,
  .options__more {
    font-weight: 500;
    font-size: .875rem;
    line-height: 1rem;
    color: #495057;
  }
  .options__more {
    color: #868E96;
  }
  .options__quantity {
    font-size: .750rem;
    line-height: .875rem;
    color: #868E96;
  }
</style>